// Экран 01 · Вход: по коду из ПИСЬМА или по паролю. SMY-68, SMY-121, SMY-175
//
// Раскладка веб-макета W01: обещание слева на фоне, форма справа на белом,
// 560px.
//
// ⚠️ Копирайт обещания ПЕРЕПИСАН 06.09.2026 и с design/README.md больше не
// совпадает. Прежний («Я сам подберу подходящий ИИ…») говорил про механику
// изнутри и обещал проверку результата, которой в продукте больше нет —
// сценарий проверки фактов убран в тот же день. Новый отвечает на вопрос
// человека, впервые открывшего страницу: почему это лучше, чем открыть
// знакомую нейросеть. Названий моделей в нём нет намеренно: тот, кому они
// что-то говорят, и так разберётся, а тот, ради кого страница написана, от
// них закрывает вкладку.
//
// Экран ввода кода в дизайне не нарисован (это сказано и в задаче), поэтому
// собран на тех же компонентах и в той же колонке: человек не должен решать,
// что попал на другой сайт, между «получить код» и «ввести код».
//
// Пароль появился вторым способом ВОЙТИ, но не зарегистрироваться. Отсюда
// раскладка — почта и кнопка «Попробовать бесплатно» остаются главным путём,
// а «Войти по паролю» стоит под ними ссылкой. Обратный порядок обещал бы
// новому человеку пароль, которого у него нет и завести который негде.
//
// ⚠️ ГОСТЕВОЙ РЕЖИМ В ВЕБЕ ЕСТЬ С 10.09.2026 (SMY-175), и до этого здесь
// было записано обратное — «нет и не будет». Запись снята не потому, что
// довод оказался неверным: он верен и сейчас.
//
// Доводов было три, и вот что с каждым:
//
//   1. **«Устройство» в вебе — это вкладка.** Верно. Гость в приватном окне —
//      новый гость на каждый заход. Снято ЧИСЛОМ, а не отменой: гостю здесь
//      достаётся ОДНА задача (`guest.webSignupSteps` = `[1]`), а не половина
//      бесплатного тарифа. Одна задача на приватное окно — цена привлечения;
//      половина тарифа была бы дырой, ровно как и предупреждали.
//   2. **В вебе продаётся подписка.** Тоже верно и ничего не меняет:
//      покупателю аккаунт нужен в любом случае, чек по 422-ФЗ уходит на
//      представленный адрес. Гость не покупает — он пробует.
//   3. **App Review 5.1.1(v) — требование к приложению.** Верно; гостевой
//      режим здесь появился не ради симметрии с iOS, а потому что человек
//      должен увидеть работу до того, как его о чём-то попросят.
//
// Сам этот экран остался нужен: сюда ведёт «Уже есть аккаунт? Войти» и
// предложение гостю после первого результата.
//
// Три шага те же, что на iOS: почта → код → имя. Проверка адреса берётся из
// ядра (`isValidEmail`), тексты отказов — с сервера. Переписанные в вёрстке
// заново, они разъехались бы с мобильными на первой же правке, и объяснить
// разницу было бы нечем. Правила шага почты и кода — в `email-code.ts`: с
// 21.09.2026 их же спрашивает окно перед оплатой гостя (SMY-341).
//
// Регистрация здесь заканчивается КАБИНЕТОМ, а не возвратом в работу: человек
// пришёл на пустое место, и показать ему надо, с чего начать.

import { useEffect, useRef, useState, type FormEvent } from 'react'
import { CONSENT_NOTICE, countdownLabel, deliveryLabel, formatUnit, isValidEmail } from '@smyslika/core'
import { ApiError } from '@smyslika/api-client'

import { emailCodePolicy, failText, requestCode, useCountdown, verifyCode } from '../email-code.ts'
import { useSession } from '../session.tsx'
import { Button, Field, Lockup } from '../ui/index.ts'

/**
 * Три причины остаться, под обещанием.
 *
 * Каждая — про то, чего человек боится, а не про то, что мы умеем. Первая
 * снимает выбор, которого он не хочет делать. Вторая отвечает «а сколько это
 * стоит» до того, как вопрос задан. Третья — про единственную непонятную вещь,
 * которую он видел у других: счёт в токенах.
 *
 * Переписаны 07.09.2026. Что изменилось по смыслу, а не по словам: вторая
 * называет теперь КАРТУ, а не картинки. «Сколько стоит» человека
 * останавливает реже, чем «сейчас попросят реквизиты», и второе снимается
 * одной фразой. Третья вместо «остаток в вопросах и картинках» перечисляет
 * все три единицы — и документы тоже: обещание «сразу видно, сколько чего»
 * ровно настолько правда, насколько полон этот список.
 *
 * ОТ ЭТОГО ОНИ СТАЛИ ДЛИННЕЕ, и третья на узкой колонке занимает две-три
 * строки. Точка рядом с ней выровнена по ПЕРВОЙ строке (`.signin__benefit`),
 * а не по середине абзаца, — иначе она висит напротив пустого места.
 */
const BENEFITS = [
  'Не нужно разбираться в нейросетях — подберём подходящую сами',
  'Есть бесплатный тариф, подключить можно без банковской карты',
  'Никаких токенов и сложных лимитов — сразу видно, сколько вопросов можно задать, сколько картинок сделать и сколько документов разобрать',
]

function Promise_() {
  return (
    <div className="signin__promise">
      <Lockup height={21} />

      <div className="signin__pitch">
        <h1 className="signin__title">Напиши, что тебе нужно, и получи результат</h1>
        <p className="signin__lead">
          Смыслика объединяет сразу множество нейросетей. Мы автоматически определим, какая из них лучше
          справится с твоей задачей для лучшего результата. Тебе не нужно разбираться в ИИ и знать, чем одна
          нейросеть отличается от другой. Просто опиши своими словами, что нужно, — и получи готовый
          результат.
        </p>
        <ul className="signin__benefits">
          {BENEFITS.map((b) => (
            <li key={b} className="signin__benefit">
              <span className="signin__dot" />
              {b}
            </li>
          ))}
        </ul>
      </div>

      <p className="signin__disclaimer">Информационная помощь — не официальное разъяснение.</p>
    </div>
  )
}

export function SignIn() {
  const { account, auth, expired, reference, signedInNow } = useSession()
  const { codeLength, cooldown, delivery } = emailCodePolicy(reference)
  // Сколько вопросов даёт бесплатный тариф. Нет справочника — нет и числа:
  // выдуманное обещание хуже отсутствующего.
  const free = reference?.tariffs.find((t) => t.id === 'free')
  const freeQuestions = free?.limits.questions
  // Картинки и документы названы вместе с вопросами: третий буллет обещает,
  // что «сразу видно, сколько чего», и число под кнопкой — единственное место
  // до входа, где это подтверждается. Назвать там две единицы из трёх значило
  // бы обещать список и показать его наполовину.
  const freeImages = free?.limits.images
  const freeDocuments = free?.limits.documents

  /**
   * Четыре шага, а не набор флагов. Флагом «код отправлен» состояний хватало
   * ровно до пароля; с именем их стало четыре, и булевы дали бы невозможное
   * «и код введён, и имя».
   */
  const [step, setStep] = useState<'email' | 'code' | 'name' | 'password'>('email')
  const [email, setEmail] = useState('')
  const [code, setCode] = useState('')
  const [name, setName] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)
  /** Момент, когда откроется повтор. `null` — код ещё не просили. */
  const [waitUntil, setWaitUntil] = useState<number | null>(null)
  const codeField = useRef<HTMLInputElement>(null)
  const nameField = useRef<HTMLInputElement>(null)
  const passwordField = useRef<HTMLInputElement>(null)

  // Пишем срок словами на кнопке, а не «попробуйте позже»: человеку есть чего
  // ждать, и ждать он должен зная сколько.
  const wait = useCountdown(waitUntil)

  // Фокус в нужное поле при смене шага: иначе человек, только что получивший
  // письмо, обязан ещё и попасть курсором в поле.
  useEffect(() => {
    if (step === 'code') codeField.current?.focus()
    if (step === 'name') nameField.current?.focus()
    if (step === 'password') passwordField.current?.focus()
  }, [step])

  const fail = (e: unknown): void => setError(failText(e))

  /** Код на адрес. Уже отправленный (`too_soon`) пускает к полю кода — `requestCode`. */
  async function askCode(): Promise<void> {
    setError(null)
    setBusy(true)
    const res = await requestCode(auth, email, cooldown)
    if (res.ok || res.waitUntil != null) {
      setStep('code')
      setWaitUntil(res.waitUntil ?? null)
    }
    if (!res.ok) setError(res.error)
    setBusy(false)
  }

  async function submitCode(): Promise<void> {
    setError(null)
    setBusy(true)
    const res = await verifyCode(auth, email, code)
    if (!res.ok) {
      if (res.clearCode) {
        setCode('')
        codeField.current?.focus()
      }
      setError(res.error)
      setBusy(false)
      return
    }
    // Токен гостя, подтвердившего свободную почту, сессия перекладывает сама
    // (`settle` в session.tsx) — и этот вызов, и окно перед оплатой идут через неё.
    await signedInNow()
    setBusy(false)
    // Вошли в существующий аккаунт: имя у человека уже есть, и спрашивать
    // его третьим шагом незачем — он попадает прямо в кабинет.
    if (res.verified.outcome !== 'signed_in') setStep('name')
  }

  /**
   * Имя — третий шаг, и он ЗАКРЫВАЕТСЯ. Регистрация завершена подтверждением
   * почты: бросивший здесь уже подтверждён, лимиты у него полные, второй раз
   * код не спросят.
   */
  async function submitName(): Promise<void> {
    setError(null)
    setBusy(true)
    try {
      await account.setName(name.trim())
      await signedInNow()
    } catch (e) {
      fail(e)
    } finally {
      setBusy(false)
    }
  }

  async function submitPassword(): Promise<void> {
    setError(null)
    setBusy(true)
    try {
      await auth.withPassword(email, password, 'Веб')
      await signedInNow()
    } catch (e) {
      // Поле чистим по тому же доводу, что и код: следующее действие —
      // ввод заново, и стирать неверное за человека наша работа.
      // На 429 не чистим: пробовать сейчас всё равно нечего.
      if (e instanceof ApiError && e.status !== 429) {
        setPassword('')
        passwordField.current?.focus()
      }
      fail(e)
    } finally {
      setBusy(false)
    }
  }

  const onSubmit = (e: FormEvent): void => {
    e.preventDefault()
    if (step === 'code') return void submitCode()
    if (step === 'name') return void submitName()
    if (step === 'password') return void submitPassword()
    void askCode()
  }

  /** Возврат к адресу. Общий для шагов: набранное чужому шагу ни к чему. */
  const backToEmail = (): void => {
    setStep('email')
    setCode('')
    setPassword('')
    setError(null)
  }

  const emailReady = isValidEmail(email)
  const codeReady = code.length === codeLength

  return (
    <div className="signin">
      <Promise_ />

      <div className="signin__form">
        <form onSubmit={onSubmit}>
          <div className="caps signin__caps">
            {step === 'code'
              ? 'Код из письма'
              : step === 'name'
                ? 'Как к тебе обращаться'
                : step === 'password'
                  ? 'Вход по паролю'
                  : 'Вход и регистрация'}
          </div>

          {/* Человека сюда привело истечение сессии, а не его решение. Без
              строки он решит, что его разлогинили нарочно или что сломалось.
              Ничего при этом не потеряно, и сказать об этом важнее всего. */}
          {expired && step === 'email' ? (
            <p className="signin__note signin__expired" role="status">
              Сессия закончилась — войди той же почтой. История, проекты и остатки на месте.
            </p>
          ) : null}

          {step === 'code' ? (
            <>
              <p className="signin__sentto">
                Отправили на {email}.{' '}
                <button type="button" className="signin__link" onClick={backToEmail}>
                  Изменить адрес
                </button>
              </p>

              <Field
                ref={codeField}
                boxy
                className="signin__code"
                value={code}
                inputMode="numeric"
                autoComplete="one-time-code"
                aria-label="Код из письма"
                placeholder={'—'.repeat(codeLength)}
                onChange={(e) => setCode(e.target.value.replace(/\D/g, '').slice(0, codeLength))}
              />

              <Button type="submit" wide disabled={busy || !codeReady}>
                Подтвердить
              </Button>

              {/* ⚠️ ПРО «СПАМ» — НЕ УКРАШЕНИЕ. Письмо от нового домена попадает
                  туда первым делом, и человек, не знающий об этом, считает,
                  что мы ничего не отправили, и жмёт повтор до упора в лимит.
                  Оба срока берутся с сервера: у письма они свои и с SMS не
                  совпадают ни по величине, ни по доводу. */}
              <p className="signin__note">
                Письмо идёт до {deliveryLabel(delivery)} — загляни и в папку «Спам».{' '}
                {wait > 0 ? (
                  `Запросить новый код можно через ${countdownLabel(wait)}.`
                ) : (
                  <button type="button" className="signin__link" onClick={() => void askCode()}>
                    Отправить код заново
                  </button>
                )}
              </p>
            </>
          ) : step === 'name' ? (
            <>
              <p className="signin__note">Почта подтверждена. Осталось необязательное.</p>

              <label className="signin__label" htmlFor="name">
                Имя
              </label>
              <Field
                ref={nameField}
                id="name"
                boxy
                value={name}
                autoComplete="given-name"
                placeholder="Имя"
                onChange={(e) => setName(e.target.value)}
              />

              <Button type="submit" wide disabled={busy || name.trim() === ''}>
                Сохранить
              </Button>

              {/* ⚠️ ПРОПУСК ОБЯЗАТЕЛЕН, и он не «отмена». Регистрация уже
                  завершена подтверждением почты: бросивший здесь подтверждён,
                  лимиты у него полные, второй раз код не спросят. Кнопка
                  «Отмена» на этом месте обещала бы обратное. */}
              <p className="signin__note">
                <button type="button" className="signin__link" onClick={() => void signedInNow()}>
                  Пропустить
                </button>{' '}
                — имя можно указать позже в профиле.
              </p>
            </>
          ) : step === 'password' ? (
            <>
              <label className="signin__label" htmlFor="email-pw">
                Почта
              </label>
              <Field
                id="email-pw"
                boxy
                value={email}
                type="email"
                inputMode="email"
                autoComplete="username"
                placeholder="имя@почта.ру"
                onChange={(e) => setEmail(e.target.value)}
              />

              <label className="signin__label" htmlFor="password">
                Пароль
              </label>
              <Field
                ref={passwordField}
                id="password"
                boxy
                value={password}
                type="password"
                autoComplete="current-password"
                onChange={(e) => setPassword(e.target.value)}
              />

              <Button type="submit" wide disabled={busy || !emailReady || password === ''}>
                Войти
              </Button>

              {/* Пароль забывается, и это не тупик: код из письма и есть
                  восстановление, другого способа у нас нет. */}
              <p className="signin__note">
                Забыл пароль?{' '}
                <button
                  type="button"
                  className="signin__link"
                  onClick={() => {
                    setStep('email')
                    setPassword('')
                    setError(null)
                  }}
                >
                  Войти по коду из письма
                </button>
              </p>
            </>
          ) : (
            <>
              <label className="signin__label" htmlFor="email">
                Почта
              </label>
              <Field
                id="email"
                boxy
                value={email}
                type="email"
                inputMode="email"
                autoComplete="email"
                autoFocus
                placeholder="имя@почта.ру"
                // Проверка адреса — та же функция ядра, что на iOS
                // (`isValidEmail`). Переписанная здесь заново, она разошлась бы
                // с мобильной на первой правке, и объяснить разницу было бы
                // нечем: клиент пускал бы то, что сервер отвергает.
                onChange={(e) => setEmail(e.target.value)}
              />

              <Button type="submit" wide disabled={busy || !emailReady}>
                Попробовать бесплатно
              </Button>

              {/* Число берётся из справочника, а не стоит в вёрстке: лимиты
                  меняются из админки без релиза (SMY-57), а это обещание —
                  единственное, что сказано про бесплатный тариф ДО входа.
                  Застывшее здесь, оно пережило слияние лимитов и продолжало
                  обещать «40 вопросов и 10 поисков», которых больше нет. */}
              <p className="signin__note">
                Пришлём код в письме.
                {freeQuestions != null
                  ? ` На бесплатном тарифе — ${[
                      formatUnit(freeQuestions, 'questions'),
                      ...(freeDocuments != null ? [formatUnit(freeDocuments, 'documents')] : []),
                      ...(freeImages != null ? [formatUnit(freeImages, 'images')] : []),
                    ]
                      // «50 вопросов, 10 документов и 20 изображений»: последнее
                      // через «и», остальные через запятую. Перечисление, а не
                      // список через запятую до конца, — читается как речь.
                      .reduce((line, part, i, all) => (i === 0 ? part : `${line}${i === all.length - 1 ? ' и' : ','} ${part}`), '')
                    } в месяц, карта не нужна.`
                  : ' Бесплатный тариф — без карты.'}
              </p>

              {/* Ссылкой и ПОД основной кнопкой: пароль есть только у того,
                  кто уже заводил аккаунт, а этот экран в первую очередь для
                  тех, у кого его нет. Регистрации по паролю не существует. */}
              <p className="signin__note">
                Уже заводил пароль?{' '}
                <button
                  type="button"
                  className="signin__link"
                  onClick={() => {
                    setStep('password')
                    setError(null)
                  }}
                >
                  Войти по паролю
                </button>
              </p>
            </>
          )}

          {error != null ? (
            <p className="signin__error" role="alert">
              {error}
            </p>
          ) : null}
        </form>

        <hr className="signin__divider" />
        <p className="signin__note">
          {step === 'code'
            ? 'Если письма нет через минуту — проверь папку «Спам» и сам адрес: опечатка в одной букве уводит код чужому человеку.'
            : step === 'name'
              ? 'Имя нужно только для обращения. Его видно в профиле и можно убрать в любой момент.'
              : step === 'password'
                ? 'Логин — твоя почта. Пароль заводится уже внутри, в профиле: зарегистрироваться можно только кодом из письма.'
                : `Уже пользовался приложением? Введи ту же почту — попадёшь в свой аккаунт с той же историей и остатками. ${CONSENT_NOTICE}`}
        </p>
      </div>
    </div>
  )
}
